export function previewConversations<T extends { id: string }>(
  ordered: readonly T[],
  expanded: boolean,
  active: string | null,
): T[] {
  if (expanded) return [...ordered];
  return ordered.filter((one, index) => index < 3 || one.id === active);
}
